import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Box, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AppStoreState, LESSON_PLANNER_MODE } from 'types';
import { parseQueryParams } from 'util/query-params-util';
import { setLessonPlannerNavbarAttribute as setLessonPlannerView } from 'state/modules/lessonPlanner/thunks';
import { translate } from 'translations/translator';

const t = key => translate('lessonPlanner', key);

export function LessonPlannerViewToggle() {
  const navigate = useNavigate();
  const dispatch = useDispatch() as any;
  const location = useLocation();
  const classes = useStyles()();
  const { bookCode, edition } = useParams<any>();
  const { mode } = useSelector((state: AppStoreState) => state.lessonPlanner, shallowEqual);
  const { selectedClassroomId } = useSelector((state: AppStoreState) => state.app);
  const user = useSelector(({ user }: AppStoreState) => user);

  const handleViewAssignments = () => {
    const queryParams = parseQueryParams(location.search);

    if (queryParams?.assignment || location.pathname.includes('/view')) {
      navigate(`/books/${bookCode}/${edition}/lesson-planner`);
    }

    dispatch(setLessonPlannerView('mode', LESSON_PLANNER_MODE.ASSIGNMENTS));
  };

  const handleViewLessonPlanner = () => {
    const queryParams = parseQueryParams(location.search);

    if (queryParams?.assignment || location.pathname.includes('manage-options')) {
      navigate(`/books/${bookCode}/${edition}/lesson-planner`);
    }

    dispatch(setLessonPlannerView('mode', LESSON_PLANNER_MODE.LESSON_PLANNER));
  };

  if (user.isAuditor) return <></>;

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <Typography style={{ color: '#000000' }}>{t('view')}</Typography>
      <ToggleButtonGroup
        value={mode}
        exclusive
        aria-label="lesson plan view options"
        className={classes.buttonGroup}
      >
        <ToggleButton
          value={LESSON_PLANNER_MODE.LESSON_PLANNER}
          aria-label="lesson plan button"
          onClick={handleViewLessonPlanner}
          style={mode === LESSON_PLANNER_MODE.LESSON_PLANNER ? { backgroundColor: '#fff' } : {}}
        >
          {t('lessonPlan')}
        </ToggleButton>
        <ToggleButton
          disabled={!selectedClassroomId}
          value={LESSON_PLANNER_MODE.ASSIGNMENTS}
          aria-label="assignments button"
          onClick={handleViewAssignments}
          style={mode === LESSON_PLANNER_MODE.ASSIGNMENTS ? { backgroundColor: '#fff' } : {}}
        >
          {t('assignments')}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

const useStyles = () =>
  makeStyles(() => ({
    buttonGroup: {
      margin: '10px 32px',
      textTransform: 'none',
      '& .Mui-selected': {
        color: '#0000008A !important'
      },
      '& .MuiToggleButton-root': {
        width: 132,
        textTransform: 'none',
        color: '#000000',
        height: 37,
        padding: 0,
        border: '2px solid #000000',

        '&:disabled': {
          backgroundColor: '#A6A6A6',
          color: '#fff'
        }
      }
    }
  }));
